import { getI18n } from "react-i18next";

export function generateMessage() {
    const i18n = getI18n();
    const allowedMessages = [
        i18n.t("LoadingMessage.message1"),
        i18n.t("LoadingMessage.message2"),
        i18n.t("LoadingMessage.message3"),
        i18n.t("LoadingMessage.message4"),
    ];

    return allowedMessages[Math.floor(Math.random() * allowedMessages.length)];
}
